import React from "react";
import Highcharts from "highcharts";
import { Paper, CardContent } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";
function InsuranceChart({details}: any) {
  const theme = useTheme();
  let chartOptions = {
    chart: {
      backgroundColor: "#fff",
      plotBackgroundColor: "#fff",
      type: "pie",
      options3d: {
        enabled: true,
        alpha: 45,
        // beta: 15,
        // depth: 50,
        // viewDistance: 25,
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Insurance details",
      align: "left",
      style: {
        color: "#242424",
      },
    },
    subtitle: {
      text: "",
      align: "left",
    },
    plotOptions: {
      pie: {
        innerSize: 60,
        depth: 45,
        size: "80%",
        allowPointSelect: true,
        cursor: "pointer",
      },
    },
    legend: {
      itemStyle: {
        color: "#242424",
      },
    },
    tooltip: {
      enabled: true,
      pointFormat: "{point.name}: <b>{point.y}</b> Patients ({point.percentage:.1f}%)", // Customize tooltip content
    },
    series: [
      {
        name: "Patients",
        data: [
          ["Claimed insurance", details?.claimedInsurance ?? 0],
          ["Rejected claim", details?.rejectedClaim ?? 0],
          ["Active Insurance", details?.activeInsurance ?? 0],
          ["Submitted insurance", details?.submittedInsurance ?? 0]
        ],
      },
    ],
  };
  const backgroundColor = theme.palette.mode === "light" ? true : false;
  React.useEffect(() => {
    console.log(details);
    
    const bgColor = {
      light: "#fff",
      dark: "#242424",
    };
    const textColor = {
      light: "#242424",
      dark: "#fff",
    };
    if (backgroundColor) {
      chartOptions.chart.backgroundColor = bgColor.light;
      chartOptions.chart.plotBackgroundColor = bgColor.light;
      chartOptions.title.style.color = textColor.light;
      chartOptions.legend.itemStyle.color = textColor.light;
    } else {
      chartOptions.chart.backgroundColor = bgColor.dark;
      chartOptions.chart.plotBackgroundColor = bgColor.dark;
      chartOptions.title.style.color = textColor.dark;
      chartOptions.legend.itemStyle.color = textColor.dark;
    }
    // Highcharts3D(Highcharts);
  }, [details, backgroundColor]);
  return (
    <Paper elevation={3}>
      <CardContent>
         <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </CardContent>
    </Paper>
  );
}

export default InsuranceChart;
